import { makeSelectAuthApiConfig } from 'services/api/api.selectors';
import { RequestApiDataIfNecessaryPayload } from 'services/api/api.types';
import { grantEndpoint } from 'services/grant/grant.config';
import { PostGrantResponse } from 'services/grant/grant.types';
import { AppState, ReduxSelector } from 'store/types';

export const selectGrantState = (reduxState: AppState) => reduxState.grant;

export const selectGrant: ReduxSelector<PostGrantResponse> = (
  reduxState: AppState,
) => selectGrantState(reduxState).grant;

/**
 * Run only after the VerifySession.
 */
export function makeSelectPostGrantApiConfig({
  requestId,
}: {
  requestId: string;
}): ReduxSelector<RequestApiDataIfNecessaryPayload> {
  return function selectCreateSubmitDepositDemandApiConfig(
    reduxState: AppState,
  ): RequestApiDataIfNecessaryPayload {
    return {
      resourceId: grantEndpoint,
      requestConfig: makeSelectAuthApiConfig({
        method: 'GET',
        url: grantEndpoint,
        enrichRequestData: false,
        headers: {
          'x-call-id': requestId,
        },
      })(reduxState),
      skipDefaultServerErrorHandling: true,
    };
  };
}
